/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AutomaticPauseConfig } from '../../models/automatic-pause-config';
import { AutomaticPauseType } from '../../models/automatic-pause-type';

export interface GetStoreAutomaticPauseOrderingConfig$Params {
  'Active-Tenant-Identifier': string;
  storeId: string;
  configurationType?: AutomaticPauseType;
}

export function getStoreAutomaticPauseOrderingConfig(http: HttpClient, rootUrl: string, params: GetStoreAutomaticPauseOrderingConfig$Params, context?: HttpContext): Observable<StrictHttpResponse<AutomaticPauseConfig>> {
  const rb = new RequestBuilder(rootUrl, getStoreAutomaticPauseOrderingConfig.PATH, 'get');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
    rb.path('storeId', params.storeId, {});
    rb.query('configurationType', params.configurationType, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AutomaticPauseConfig>;
    })
  );
}

getStoreAutomaticPauseOrderingConfig.PATH = '/stores/{storeId}/automatic-pauses';
